function SupportPage() {
  return (
    <main>
      <h1>Supporto LaBraseriaApp</h1>
      <p>
        Benvenuto nella pagina di supporto dell'applicazione LaBraseriaApp!
        Siamo qui per fornirti assistenza e risolvere eventuali problemi che
        potresti incontrare durante l'utilizzo dell'app. Sappiamo quanto sia
        importante avere un'esperienza senza problemi e faremo del nostro meglio
        per aiutarti.
        <br />
        <br /> Se hai domande generali sull'app o sulle sue funzionalità, ti
        incoraggiamo a contattare direttamente il nostro team di supporto. Siamo
        pronti ad ascoltare le tue domande e a fornirti assistenza
        personalizzata.
        <br />
        <br />
        Se riscontri problemi tecnici con l'app, ti consigliamo di verificare se
        hai la versione più recente dell'app installata sul tuo dispositivo. In
        alcuni casi, potrebbe essere necessario effettuare un aggiornamento per
        risolvere eventuali bug o problemi noti. Se l'aggiornamento non risolve
        il problema, ti invitiamo a contattarci e fornirci il maggior numero di
        dettagli possibile sulla situazione. Questo ci aiuterà a comprendere
        meglio la natura del problema e a fornirti una soluzione adeguata.
        <br />
        <br /> Siamo consapevoli che ogni feedback è prezioso per noi. Se hai
        suggerimenti per migliorare l'app o desideri segnalare un bug, ti
        preghiamo di contattarci. Apprezziamo il tuo contributo e lavoriamo
        costantemente per rendere l'applicazione migliore e più soddisfacente
        per tutti gli utenti.
      </p>
      <p>
        <b>Email di supporto:</b> info@la-braseria.com
      </p>
    </main>
  );
}

export default SupportPage;
